import script from "./ExercisePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExercisePage.vue?vue&type=script&setup=true&lang=ts"

import "./ExercisePage.vue?vue&type=style&index=0&id=3016a535&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3016a535"]])

export default __exports__